/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S33_TitleInputs */

const es_privacy_policy_data_collected_s33_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.3 Informacion que derivamos de sus datos`)
};

const en_privacy_policy_data_collected_s33_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.3 Information We Derive From Your Data`)
};

/**
* | output |
* | --- |
* | "3.3 Information We Derive From Your Data" |
*
* @param {Privacy_Policy_Data_Collected_S33_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s33_title = /** @type {((inputs?: Privacy_Policy_Data_Collected_S33_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S33_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s33_title(inputs)
	return en_privacy_policy_data_collected_s33_title(inputs)
});
export { privacy_policy_data_collected_s33_title as "privacy_policy.data_collected.s33_title" }